import { displayLabelIfExists } from '@app/domain/instrument/instrument.helpers'
import type {
  IProgram,
  IProgramInteraction,
  IProgramInteractionId,
  ProgramInteractionTypeId,
} from '@app/domain/program/program.interface'

export const daysRemainingUntilInteraction = (
  initialInteractionCompletedDate: Date,
  interaction: IProgramInteraction,
) => {
  if (
    initialInteractionCompletedDate &&
    interaction.daysAfterInitialInteraction
  ) {
    const oneDay = 1000 * 60 * 60 * 24
    const today = new Date()
    const date = new Date(initialInteractionCompletedDate.valueOf())
    date.setDate(date.getDate() + interaction.daysAfterInitialInteraction)
    const diffInTime = date.getTime() - today.getTime()
    const diffInDays = Math.round(diffInTime / oneDay)
    return diffInDays
  } else {
    return null
  }
}

export const findNearestInteractionId = (
  initialInteractionCompletedDate: Date,
  program: IProgram,
  programInteractionHistory: Record<IProgramInteractionId, Date>,
  programInteractionType: ProgramInteractionTypeId,
) => {
  if (initialInteractionCompletedDate) {
    const uncompletedInteractions = program.interactions[programInteractionType]
      ?.filter((i) => programInteractionHistory[i.id] === undefined)
      .filter((i) => i.daysAfterInitialInteraction)
    if (uncompletedInteractions?.length > 0) {
      return uncompletedInteractions.sort((a, b) => {
        return (
          Math.abs(
            daysRemainingUntilInteraction(initialInteractionCompletedDate, a),
          ) -
          Math.abs(
            daysRemainingUntilInteraction(initialInteractionCompletedDate, b),
          )
        )
      })?.[0].id
    } else {
      return null
    }
  } else {
    return null
  }
}

export const createDaysRemainingLabel = (
  initialInteractionCompletedDate: Date,
  interaction: IProgramInteraction,
  nearestRemoteInteractionId: IProgramInteractionId,
  programInteractionHistory: Record<IProgramInteractionId, Date>,
) => {
  const daysRemaining = daysRemainingUntilInteraction(
    initialInteractionCompletedDate,
    interaction,
  )
  const interactionIsComplete =
    programInteractionHistory[interaction.id] !== undefined

  const instruments = interaction.instruments.map(displayLabelIfExists)

  let daysRemainingText = ''
  if (daysRemaining !== null) {
    daysRemainingText =
      daysRemaining < 0
        ? `${Math.abs(daysRemaining)} days ago`
        : `${daysRemaining} days away`
  }

  let daysRemainingLabel

  if (daysRemaining === null) {
    daysRemainingLabel = `${instruments.join(', ')}`
  } else if (interactionIsComplete) {
    daysRemainingLabel = `${instruments.join(', ')} (Completed)`
  } else if (interaction.id === nearestRemoteInteractionId) {
    daysRemainingLabel = `${instruments.join(
      ', ',
    )} (${daysRemainingText}, nearest to visit)`
  } else {
    daysRemainingLabel = `${instruments.join(', ')} (${daysRemainingText})`
  }

  return daysRemainingLabel
}
